import styled from 'styled-components'

export const TRANSITION_DURATION = 10000

export const Root = styled.div`
  .Type__fade-enter {
    opacity: 0;
    z-index: 1;
  }

  .Type__fade-enter.Type__fade-enter-active {
    opacity: 1;
    transition: opacity ${TRANSITION_DURATION}ms ease-in;
  }

  .Type__fade-exit.Type__fade-exit-active {
    opacity: 0;
    transition: opacity ${TRANSITION_DURATION}ms ease-in;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Type.styles.ts